import Vendor from "~/pages/vendor";

export default Vendor;
